import styled from '@emotion/styled';
import { theme } from '../../theme';
export const StyledSpinner = styled.div `
	padding-top: ${theme.spacing.space10};
	svg {
		@keyframes rotation {
			from {
				transform: rotate(0deg);
			}
			to {
				transform: rotate(359deg);
			}
		}
		animation: rotation 1s infinite linear;
	}
`;
//# sourceMappingURL=Spinner.styled.js.map